import React from "react";
import {
  Box,
  Typography,
  FormControlLabel,
  Switch,
  Stack,
} from "@mui/material";
import { WarningAmber } from "@mui/icons-material";
import {
  MedicationOptions,
  medicationTypeOptions,
  routeAdminOptions,
} from "../../medication.config";
import CustomInput from "../../../../../FormFields/CustomInput";
import CustomSelect from "../../../../../FormFields/CustomSelect/CustomSelect";
import CustomRichText from "../../../../../CustomForm/CustomRichText";

const MedicationBasicInfo = ({ formData = {}, handleChange, errors = {} }) => {
  const handleNotesChange = (value) => {
    handleChange({
      target: {
        name: "notes",
        value,
      },
    });
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 700, color: "#475569", mb: 2, fontSize: "0.82rem" }}
      >
        Administration System{" "}
        <Typography component="span" color="#ef4444">
          *
        </Typography>
      </Typography>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2.5 }}>
        <Box sx={{ flex: "1 1 45%", minWidth: "280px" }}>
          <Stack spacing={2.5}>
            <CustomSelect
              label="Select Medication Type"
              name="medicine_type"
              options={MedicationOptions}
              value={formData.medicine_type}
              onChange={handleChange}
              error={!!errors.medicine_type}
              helperText={errors.medicine_type}
              fullWidth
            />

            <CustomInput
              label="Medication Title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              error={!!errors.title}
              helperText={errors.title}
              placeholder="e.g., Morning Medication Schedule"
              required
              fullWidth
            />

            <CustomSelect
              label="Route of Administration"
              name="route_administration"
              options={routeAdminOptions}
              value={formData.route_administration}
              onChange={handleChange}
              error={!!errors.route_administration}
              helperText={errors.route_administration}
              searchable={true}
              required
              fullWidth
            />

            <FormControlLabel
              control={
                <Switch
                  name="controlled_medication"
                  checked={!!formData.controlled_medication}
                  onChange={handleChange}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": { color: "#dc2626" },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#dc2626",
                    },
                  }}
                />
              }
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <WarningAmber
                    sx={{
                      fontSize: 16,
                      color: formData.controlled_medication
                        ? "#dc2626"
                        : "#94a3b8",
                    }}
                  />
                  <Typography variant="body2" fontWeight={500}>
                    Controlled Drug (CD)
                  </Typography>
                </Box>
              }
            />
          </Stack>
        </Box>

        <Box sx={{ flex: "1 1 45%", minWidth: "280px" }}>
          <Stack spacing={2.5}>
            <CustomSelect
              label="Medication Form"
              name="medication_type"
              options={medicationTypeOptions}
              value={formData.medication_type}
              onChange={handleChange}
              error={!!errors.medication_type}
              helperText={errors.medication_type}
              searchable={true}
              fullWidth
            />

            <CustomInput
              label="Reason for Medication"
              name="reason_for_medication"
              value={formData.reason_for_medication}
              onChange={handleChange}
              error={!!errors.reason_for_medication}
              helperText={errors.reason_for_medication}
              placeholder="e.g., Pain relief, blood pressure control..."
              fullWidth
            />

            <Box>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 600,
                  color: "#475569",
                  mb: 0.75,
                  display: "block",
                  fontSize: "0.75rem",
                }}
              >
                Notes / PRN Protocol
              </Typography>
              <CustomRichText
                value={formData.notes || ""}
                onChange={handleNotesChange}
                placeholder="Enter any special instructions or PRN protocol..."
              />
            </Box>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default MedicationBasicInfo;